import { PatientResponseDto } from "@/data/dto/patient-reponse-dto";
import { PatientTableInfoEntity } from "@/domain/entity/patient/patient-table-info-entity";
import { assertPatientResponseDto } from "@/utils/validation";
import { PatientInfoMapper } from "./patient-info-mapper";

export class PatientListInfoMapper {
  static toEntity(patientListResponseDto: PatientResponseDto[]): PatientTableInfoEntity[] {
    // 배열의 각 요소를 개별적으로 검증
    if (!Array.isArray(patientListResponseDto)) {
      throw new Error("[PatientListInfoMapper] :: toEntity :: input must be an array");
    }

    // 각 환자 데이터를 검증
    patientListResponseDto.forEach((patient, index) => {
      try {
        assertPatientResponseDto(patient);
      } catch (error) {
        throw new Error(
          `[PatientListInfoMapper] :: toEntity :: Validation failed at index ${index}: ${
            error instanceof Error ? error.message : String(error)
          }`
        );
      }
    });

    return patientListResponseDto.map((patient) => PatientInfoMapper.toEntity(patient));
  }
}
